import React from 'react';

const TrendIndicator = ({ current, previous }) => {
  const diff = current - previous;
  const trend = diff > 0 ? 'up' : diff < 0 ? 'down' : 'stable';
  const color = trend === 'up' ? 'text-emerald-500' : trend === 'down' ? 'text-red-500' : 'text-slate-400';
  const arrow = trend === 'up' ? '↑' : trend === 'down' ? '↓' : '→';

  return (
    <div className="text-center">
      <p className="text-5xl font-bold text-slate-900 mb-2">{current}%</p>
      <div className={`flex items-center justify-center gap-2 ${color}`}>
        <span className="text-2xl">{arrow}</span>
        <span className="text-sm font-medium">
          {trend === 'stable' ? 'No change' : `${Math.abs(diff).toFixed(1)}% vs last month`}
        </span>
      </div>
      <p className="text-slate-400 text-xs mt-1">Previous: {previous}%</p>
    </div>
  );
};

export default TrendIndicator;
